




































import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AuthUser, defaultAuthUser } from '@/api'
import { authUserStore, pageStore } from '@/utils/store-accessor'

@Component({
  components: {}
})
export default class ThePageTitle extends ComponentVue {
  @Prop({
    type: [String]
  })
  title!: string

  get cssCustomProperty(): any {
    return {
      '--background-color': pageStore.titleColor
    }
  }

  get authUser(): AuthUser {
    const authUser = authUserStore.authUser
    if (authUser === undefined) {
      return defaultAuthUser()
    }

    return authUser
  }

  @Emit('click:help')
  onClickHelp() {}
}
